// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Cx0","colMin":"styles_colMin__2tfd7"};